import { Extension } from "@tiptap/core";
import { Plugin } from "@tiptap/pm/state";

const MAX_PASTE_LENGTH = 100000;

export function looksLikeMarkdown(value) {
  if (typeof value !== "string" || !value || value.length > MAX_PASTE_LENGTH) return false;
  const text = value.replaceAll("\r\n", "\n");

  if (/^(?:#{1,6})[ \t]+\S/m.test(text)) return true;
  if (/^[ \t]*>[ \t]+\S/m.test(text)) return true;
  if (/^[ \t]*```[^\n]*$/m.test(text) && /\n[\s\S]*\n[ \t]*```[ \t]*$/m.test(text)) return true;
  if (/^[ \t]*(?:-{3,}|\*{3,}|_{3,})[ \t]*$/m.test(text)) return true;

  const bulletLines = text.match(/^[ \t]*[-+*][ \t]+\S.*$/gm) || [];
  if (bulletLines.length >= 2) return true;
  const orderedLines = text.match(/^[ \t]*\d+[.)][ \t]+\S.*$/gm) || [];
  if (orderedLines.length >= 2) return true;

  if (/\*\*[^*\n]+\*\*|__[^_\n]+__/.test(text)) return true;
  if (/~~[^~\n]+~~/.test(text)) return true;
  if (/(^|[^`])`[^`\n]+`([^`]|$)/.test(text)) return true;
  return /\[[^\]\n]{1,200}\]\((?:https?:\/\/|mailto:)[^\s)]+\)/i.test(text);
}

export function handleMarkdownPaste({ editor, event, onTitle }) {
  const clipboard = event?.clipboardData;
  if (!clipboard) return false;
  const text = clipboard.getData("text/plain") || "";
  if (!looksLikeMarkdown(text) || typeof editor?.markdown?.parse !== "function") return false;

  try {
    const parsed = editor.markdown.parse(text);
    const document = typeof onTitle === "function" ? structuredClone(parsed) : parsed;
    const titleIndex = typeof onTitle === "function"
      ? document.content?.findIndex((node) => node.type === "heading" && node.attrs?.level === 1) ?? -1
      : -1;
    const title = titleIndex >= 0 ? nodeText(document.content[titleIndex]).trim() : "";
    if (titleIndex >= 0) document.content.splice(titleIndex, 1);
    const rollbackTitle = title ? onTitle(title) : undefined;
    let inserted;
    try {
      inserted = editor.commands.insertContent(document);
    } catch (error) {
      rollbackTitle?.();
      throw error;
    }
    if (inserted === false) {
      rollbackTitle?.();
      return false;
    }
    event.preventDefault();
    return true;
  } catch {
    return false;
  }
}

export const PasteMarkdown = Extension.create({
  name: "pasteMarkdown",

  addOptions() {
    return { onTitle: () => {} };
  },

  addProseMirrorPlugins() {
    return [new Plugin({
      props: {
        handlePaste: (_view, event) => handleMarkdownPaste({ editor: this.editor, event, onTitle: this.options.onTitle })
      }
    })];
  }
});

function nodeText(node) {
  if (node?.type === "text") return node.text || "";
  return (node?.content || []).map(nodeText).join(node?.type === "hardBreak" ? "\n" : "");
}
